import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

class Cover extends React.Component {
  render() {
    return (
      <Paper style={{ position: 'absolute', left: '50%', top: '50%', padding: 20, transform: 'translate(-50%, -50%)' }} elevation={1}>
        <Typography align="center" variant="h5">{this.props.message}</Typography>
      </Paper>
    );
  }
}

Cover.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
};

export default Cover;
